import React from "react";

const Pagination = ({
  currentPage,
  lastPage,
  perPage,
  onPageChange,
  onPerPageChange,
}) => {
  const pages = Array.from({ length: lastPage }, (_, i) => i + 1);

  const PreviousButtonSVG = ({ disabled }) => (
    <svg
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="5.33333" y="0.5" fill="white" />
      <path
        d="M18 21.5L13.42 16.4992L18 11.5"
        stroke={disabled ? "#898989" : "#2D71E2"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const NextButtonSVG = ({ disabled }) => (
    <svg
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="5.33333" y="0.5" fill="white" />
      <path
        d="M14 21.5L18.58 16.4992L14 11.5"
        stroke={disabled ? "#898989" : "#2D71E2"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (
    <div className="pagination-controls justify-content-between mt-40 mb-77">
      {/* Dropdown éléments par page */}
      <div className="results-per-page">
        <select
          id="resultsPerPage"
          className="form-select-option"
          style={{ width: "70px" }}
          value={perPage}
          onChange={(e) => onPerPageChange(Number(e.target.value))}
        >
          {[5, 10, 25, 50, 100].map((num) => (
            <option key={num} value={num}>
              {num}
            </option>
          ))}
        </select>
        <label htmlFor="resultsPerPage" style={{ marginRight: "10px" }}>
          éléments par page
        </label>
      </div>

      {/* Pagination */}
      <nav>
        <ul
          className="pagination pagination-sm mb-0 d-flex align-items-center"
          style={{ gap: "10px" }}
        >
          <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
            <button
              onClick={() => onPageChange(currentPage - 1)}
              disabled={currentPage === 1}
              style={{ background: "none", border: "none", padding: 0 }}
              aria-label="Page précédente"
            >
              <PreviousButtonSVG disabled={currentPage === 1} />
            </button>
          </li>

          {pages.map((page) => (
            <li
              key={page}
              className={`page-item ${page === currentPage ? "active" : ""}`}
            >
              <button
                onClick={() => onPageChange(page)}
                className={`bloc-Pagination { ${
                  page === currentPage ? "active" : ""
                }`}
              >
                {page}
              </button>
            </li>
          ))}

          <li
            className={`page-item ${
              currentPage === lastPage ? "disabled" : ""
            }`}
          >
            <button
              onClick={() => onPageChange(currentPage + 1)}
              disabled={currentPage === lastPage}
              style={{ background: "none", border: "none", padding: 0 }}
              aria-label="Page suivante"
            >
              <NextButtonSVG disabled={currentPage === lastPage} />
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Pagination;
